import React, { useContext } from "react";
import { Row, Col, FormGroup, FormControl, FormLabel, Form } from "react-bootstrap";
import { useWizard } from "./WizardContext";
import Select from "react-select";
import { useGuestContext } from "../../../../contexts/GuestContext";
import LanguageToggle from "../LanguageToggle";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";
const Step1 = React.forwardRef((props, ref) => {
  const {
    firstname, setFirstname,
    lastname, setLastname,
    chinesename, setChinesename,
    email, setEmail,
    phone, setPhone,
    s11_5_09_30, setS11_5_09_30, 
    s18_5_09_30, setS18_5_09_30, 
    s1_6_09_30, setS1_6_09_30, 
    s8_6_09_30, setS8_6_09_30, 
    s15_6_09_30, setS15_6_09_30, 
    s6_7_09_30, setS6_7_09_30, 
    s13_7_09_30, setS13_7_09_30, 
    s20_7_09_30, setS20_7_09_30, 
    s3_8_09_30, setS3_8_09_30, 
    s10_8_09_30, setS10_8_09_30
  } = useWizard();

  const { language } = useGuestContext();

  //define error messages
  const [firstnameError, setFirstnameError] = React.useState(null);
  const [lastnameError, setLastnameError] = React.useState(null);
  const [emailError, setEmailError] = React.useState(null);
  const [phoneError, setPhoneError] = React.useState(null);
  const [chinesenameError, setChinesenameError] = React.useState(null);
 

  const handleCheckboxChange = (event, setSession) => {
    setSession(event.target.checked);
  };

  const handleNameChange = (value, setName, setError, isChineseName = false) => {
    // Regular expression for non-Chinese names: allows letters, spaces, hyphens, and apostrophes
    const nameRegex = /^[A-Za-z\s'-]+$/;
    // Regular expression for Chinese names: allows Chinese characters (including simplified and traditional), spaces, and common name characters
    const chineseNameRegex = /^[\u4e00-\u9fa5\s·]+$/;

    let isValid = isChineseName ? chineseNameRegex.test(value) : nameRegex.test(value);

    if (!isValid && value !== "") {
      setError(
        <small className="text-danger">
          {language === "English"
            ? isChineseName
              ? "Invalid characters. Only Chinese characters are allowed."
              : "Invalid characters. Only letters, spaces, hyphens, and apostrophes are allowed."
            : isChineseName
              ? "包含无效字符。只允许中文字符。"
              : "包含无效字符。只允许字母、空格、连字符和撇号。"
          }
        </small>
      );
    } else {
      setError(null);
    }
    setName(value);
  };
  const isValidated = () => {
    console.log("hey");
    // var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // re.test(email) === false
    //   ? setEmailError(
    //     <small className="text-danger">
    //       {language === "English" ? "Invalid email format. A correct format looks like john@doe.com." : "電子郵件格式不正確  正確格式類似於john@doe.com."}
    //     </small>
    //   )
    //   : setEmailError(null);
    //check firstname
    (firstname === null || firstname.trim() === "")
      ? setFirstnameError(
        <small className="text-danger">{language === "English" ? "First name is required." : "未填寫英文名"}</small>
      )
      : setFirstnameError(null);

    //check lastname
    (lastname === null || lastname.trim() === "")
      ? setLastnameError(
        <small className="text-danger">{language === "English" ? "Last name is required." : "未填寫英文姓"}</small>
      )
      : setLastnameError(null);

    (phone === null || phone.trim() === "")
      ? setPhoneError(
        <small className="text-danger">{language === "English" ? "Please enter a contact phone number." : "請填息聯繫電話以方便聯絡."}</small>
      )
      : setPhoneError(null);
    // var gd = gender !== null;
    // var em = re.test(email) === true;
    var fn = !(firstname === null || firstname.trim() === "");
    var ln = !(lastname === null || lastname.trim() === "");
    var ph = !(phone === null || phone.trim() === "");
    var valid = fn && ln && ph;
    return valid;
  };

  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      console.log("Step 1 validation");
      return isValidated();
    },
  }));

  return (
    <div className="wizard-step" ref={ref}>
      <p className="text-center mb-2 font-weight-bold">
        <img src={cuteMonk1} alt="Company Logo" width="40" className="mr-3" />
        {language === "English" ? "Personal Information" : "請提供以下個人信息"}
        <img src={cuteMonk2} alt="Company Logo" width="40" className="ml-3" />
      </p>
      <hr />
      <LanguageToggle />
      <hr />
      <Row>
        <Col md={{ span: 5, offset: 1 }}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "First Name (Required)" : "英 文 名（必填）"}<span className="text-danger">*</span>
            </FormLabel>
            <FormControl
              type="text"
              name="firstname"
              placeholder="ex: Mike"
              maxLength="30"
              value={firstname}
              onChange={(event) => handleNameChange(event.target.value, setFirstname, setFirstnameError)}
            />
            {firstnameError}
          </FormGroup>
        </Col>
        <Col md={5}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "Last Name (Required)" : "英 文 姓（必填）"}<span className="text-danger">*</span>
            </FormLabel>
            <FormControl
              type="text"
              name="lastname"
              maxLength="30"
              placeholder="ex: Andrew"
              value={lastname}
              onChange={(event) => handleNameChange(event.target.value, setLastname, setLastnameError)}
            />
            {lastnameError}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 5, offset: 1 }}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "Chinese Name" : "中 文 姓 名"}
            </FormLabel>
            <FormControl
              type="text"
              name="chinesename"
              maxLength="30"
              placeholder={language === "English" ? "ex: Wukong" : "ex：悟空"}
              value={chinesename}
              onChange={(event) => handleNameChange(event.target.value, setChinesename, setChinesenameError, true)}
            />
            {chinesenameError}
          </FormGroup>
        </Col>
        <Col md={{ span: 5 }}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "Phone Number (Required for contact)" : "電 話 號 碼（必填，聯絡用）"} <span className="text-danger">*</span>
            </FormLabel>
            <FormControl
              type="number"
              name="phone"
              maxLength="30"
              placeholder="ex: 0433233343"
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
            />
            {phoneError}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 5, offset: 1 }}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "Email (optional for contact)" : "電 子 郵 件（聯絡用）"}
            </FormLabel>
            <FormControl
              type="email"
              name="email"
              maxLength="50"
              placeholder="ex: wukong@baolin.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            {emailError}
          </FormGroup>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={{ span: 10, offset: 1 }}>
          <FormGroup>
            <FormLabel>
              {language === "English" ? "Please select the sessions you would like to participate:" : "請選擇您想要參加的共修日期"}
            </FormLabel>
            <Row>
              <Form.Check className="checkbox-inline">
                <Form.Check.Label>
                  <Form.Check.Input
                    defaultValue="s11_5_09_30"
                    type="checkbox"
                    checked={s11_5_09_30}
                    onChange={(e) => handleCheckboxChange(e, setS11_5_09_30)}
                    //disabled
                  ></Form.Check.Input>
                  <span className="form-check-sign"></span>{language === "English" ? "Scroll 1: 11/5 9:30 ~ 12:30" : "卷一: 8/9 9:30 ~ 12:30"}
                </Form.Check.Label>
              </Form.Check>
              <Form.Check className="checkbox-inline">
                <Form.Check.Label>
                  <Form.Check.Input
                    defaultValue="s18_5_09_30"
                    type="checkbox"
                    checked={s18_5_09_30}
                    onChange={(e) => handleCheckboxChange(e, setS18_5_09_30)}
                    // disabled
                  ></Form.Check.Input>
                  <span className="form-check-sign"></span>{language === "English" ? "Scroll 2: 18/5 9:30 ~ 12:30" : "卷二: 18/5 9:30 ~ 12:30"}
                </Form.Check.Label>
              </Form.Check>
              <Form.Check className="checkbox-inline">
                <Form.Check.Label>
                  <Form.Check.Input
                    defaultValue="s1_6_09_30"
                    type="checkbox"
                    checked={s1_6_09_30}
                    onChange={(e) => handleCheckboxChange(e, setS1_6_09_30)}
                    // disabled
                  ></Form.Check.Input>
                  <span className="form-check-sign"></span>{language === "English" ? "Scroll 3: 1/6 9:30 ~ 12:30" : "卷三: 1/6 9:30 ~ 12:30"}
                </Form.Check.Label>
              </Form.Check>
            </Row>
            <Row>
              <Form.Check className="checkbox-inline">
                <Form.Check.Label>
                  <Form.Check.Input
                    defaultValue="s8_6_09_30"
                    type="checkbox"
                    checked={s8_6_09_30}
                    onChange={(e) => handleCheckboxChange(e, setS8_6_09_30)}
                    // disabled
                  ></Form.Check.Input>
                  <span className="form-check-sign"></span>{language === "English" ? "Scroll 4: 8/6 9:30 ~ 12:30" : "卷四: 8/6 9:30 ~ 12:30"}
                </Form.Check.Label>
              </Form.Check>
              <Form.Check className="checkbox-inline">
                <Form.Check.Label>
                  <Form.Check.Input
                    defaultValue="s15_6_09_30"
                    type="checkbox"
                    checked={s15_6_09_30}
                    onChange={(e) => handleCheckboxChange(e, setS15_6_09_30)}
                    // disabled
                  ></Form.Check.Input>
                  <span className="form-check-sign"></span>{language === "English" ? "Scroll 5: 15/6 9:30 ~ 12:30" : "卷五: 15/6 9:30 ~ 12:30"}
                </Form.Check.Label>
              </Form.Check>
              <Form.Check className="checkbox-inline">
                <Form.Check.Label>
                  <Form.Check.Input
                    defaultValue="s6_7_09_30"
                    type="checkbox"
                    checked={s6_7_09_30}
                    onChange={(e) => handleCheckboxChange(e, setS6_7_09_30)}
                    // disabled
                  ></Form.Check.Input>
                  <span className="form-check-sign"></span>{language === "English" ? "Scroll 6: 6/7 9:30 ~ 12:30" : "卷六: 6/7 9:30 ~ 12:30"}
                </Form.Check.Label>
              </Form.Check>
            </Row>
            <Row>
              <Form.Check className="checkbox-inline">
                <Form.Check.Label>
                  <Form.Check.Input
                    defaultValue="s13_7_09_30"
                    type="checkbox"
                    checked={s13_7_09_30}
                    onChange={(e) => handleCheckboxChange(e, setS13_7_09_30)}
                    // disabled
                  ></Form.Check.Input>
                  <span className="form-check-sign"></span>{language === "English" ? "Scroll 7: 13/7 9:30 ~ 12:30" : "卷七: 13/7 9:30 ~ 12:30"}
                </Form.Check.Label>
              </Form.Check>
              <Form.Check className="checkbox-inline">
                <Form.Check.Label>
                  <Form.Check.Input
                    defaultValue="s20_7_09_30"
                    type="checkbox"
                    checked={s20_7_09_30}
                    onChange={(e) => handleCheckboxChange(e, setS20_7_09_30)}
                    // disabled
                  ></Form.Check.Input>
                  <span className="form-check-sign"></span>{language === "English" ? "Scroll 8: 20/7 9:30 ~ 12:30" : "卷八: 20/7 9:30 ~ 12:30"}
                </Form.Check.Label>
              </Form.Check>
              <Form.Check className="checkbox-inline">
                <Form.Check.Label>
                  <Form.Check.Input
                    defaultValue="s3_8_09_30"
                    type="checkbox"
                    checked={s3_8_09_30}
                    onChange={(e) => handleCheckboxChange(e, setS3_8_09_30)}
                  ></Form.Check.Input>
                  <span className="form-check-sign"></span>{language === "English" ? "Scroll 9: 3/8 9:30 ~ 12:30" : "卷九: 3/8 9:30 ~ 12:30"}
                </Form.Check.Label>
              </Form.Check>
            </Row>
            <Row>
              <Form.Check className="checkbox-inline">
                <Form.Check.Label>
                  <Form.Check.Input
                    defaultValue="s10_8_09_30"
                    type="checkbox"
                    checked={s10_8_09_30}
                    onChange={(e) => handleCheckboxChange(e, setS10_8_09_30)}
                  ></Form.Check.Input>
                  <span className="form-check-sign"></span>{language === "English" ? "Scroll 10: 10/8 13:30 ~ 16:30" : "卷十: 10/8 13:30 ~ 16:30"}
                </Form.Check.Label>
              </Form.Check>
            </Row>
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
});

export default Step1;
